/* Plan / Make / Ship circles turn once (360°, 2.6s) on hover or click to show
   their inverted reverse face. A spin in progress is never restarted, so
   moving the pointer across a circle doesn't make it stutter. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function spin(circle) {
    if (circle.classList.contains('is-spinning')) return;
    circle.classList.add('is-spinning');
  }

  function bind(scope) {
    scope.querySelectorAll('[data-features-circle]').forEach(function (circle) {
      if (circle.hasAttribute('data-features-spin-ready')) return;
      circle.setAttribute('data-features-spin-ready', '');

      circle.addEventListener('mouseenter', function () {
        spin(circle);
      });
      circle.addEventListener('click', function () {
        spin(circle);
      });
      circle.addEventListener('animationend', function (event) {
        if (event.animationName === 'ly-circle-spin') circle.classList.remove('is-spinning');
      });
    });
  }

  bind(document);

  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
